module.exports = __webpack_public_path__ + "static/media/small-close.10341313.svg";